const initialState = {
  showNav: false,
  navSteps: false,
  navSectionLinks: [],
}

const inlineNavReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INLINE_NAV":
      return {
        ...state,
        navSteps: action.payload.navSteps,
        navSectionLinks: action.payload.navSectionLinks,
      }

    case "SHOW_INLINE_NAV":
      return {
        ...state,
        showNav: action.payload.showNav,
      }

    default:
      return state
  }
}

export default inlineNavReducer
